import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const InputGroup = styled(Common.InputGroup)``;

export const TextField = styled(Common.TextField)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Button = styled(Common.Button)``;

export const FlexRow = styled(Common.FlexRow)``;

export const Select = styled(Common.Select)``;

export const MenuItem = styled(Common.MenuItem)``;

export const Dialog = styled(Common.Dialog)``;

export const DialogActions = styled(Common.DialogActions)``;

export const DialogTitle = styled(Common.DialogTitle)``;

export const DialogContent = styled(Common.DialogContent)`
	margin-top: -16px !important;
	padding: 1rem !important;
`;

export const CircularButton = styled(Common.CircularButton)``;
